import { createHelpers } from 'vuex-map-fields';

const { getSolicitudField, updateSolicitudField } = createHelpers({
  getterType: 'getSolicitudField',
  mutationType: 'updateSolicitudField',
});

export default {
  namespaced: true,
  state: {
    explicacionArticulo:[
    {
      'Id':10,
      'Articulo': '20a',
      'Descripcion':'Por duelo. Se debe realizar el aviso al establecimiento presentando acta de defunción luego la parte administrativa encargada debe cargar en el sistema con los datos correspondientes.',
      'Link': 'https://docs.saed.digital/books/circular/page/licencias-sin-goce-de-haberes'
    },
    {
      'Id':11,
      'Articulo': '20b',
      'Descripcion':'Por duelo. Se debe realizar el aviso al establecimiento presentando acta de defunción luego la parte administrativa encargada debe cargar en el sistema con los datos correspondientes.',
      'Link': 'https://docs.saed.digital/books/circular/page/licencias-sin-goce-de-haberes'
    },
    {
      'Id':12,
      'Articulo': '20c',
      'Descripcion':'Por duelo. Se debe realizar el aviso al establecimiento presentando acta de defunción luego la parte administrativa encargada debe cargar en el sistema con los datos correspondientes.',
      'Link': 'https://docs.saed.digital/books/circular/page/licencias-sin-goce-de-haberes'
    },
    {
      'Id':13,
      'Articulo': '27',
      'Descripcion':'Representación política. Adjuntar Presentación de nota y adjuntar documentación del cargo político a desempeñar firmada por las autoridades que correspondan (directivo del establecimiento y a su vez la misma elevada y autorizada por la representante legal de SAED).',
      'Link': 'https://docs.saed.digital/books/circular/page/licencias-sin-goce-de-haberes'
    },
    {
      'Id':8,
      'Articulo': '28',
      'Descripcion':'Representación gremial. Adjuntar Presentación de nota y la correspondiente documentación del cargo gremial y planilla de novedades laborales. Todo este paso debe ser previamente autorizado por autoridades del establecimiento y luego elevado a su vez a la representante legal de SAED.',
      'Link': 'https://docs.saed.digital/books/circular/page/licencias-sin-goce-de-haberes'
    },
    {
      'Id':6,
      'Articulo': '32',
      'Descripcion': 'razones particulares sin goce de haberes. Adjuntar la nota especificando su fecha desde y fecha hasta. Régimen de incompatibilidad.',
      'Link': 'https://docs.saed.digital/books/circular/page/licencias-sin-goce-de-haberes'
    },
    {
      'Id':14,
      'Articulo': '48',
      'Descripcion': 'Los trabajadores que, por ocupar cargos electivos o representativos en asociaciones sindicales con personería gremial, en organismos que requieran representación gremial, o en cargos políticos en los poderes públicos, dejarán de prestar servicios, tendrán derecho a gozar de licencia automática sin goce de haberes.',
      'Link': 'https://docs.saed.digital/books/circular/page/licencias-sin-goce-de-haberes'
    },
    {
      'Id':7,
      'Articulo': '33',
      'Descripcion':'Jerarquía, nivel o remuneración. Adjuntar Presentación de nota con la fecha de inicio, y demás documentación sobre el cargo o función a desempeñar firmada por las autoridades que correspondan (directivo del establecimiento y a su vez la misma elevada y autorizada por la representante legal de SAED). Esto luego lleva un proceso de control y autorización por el área legal.',
      'Link': 'https://docs.saed.digital/books/circular/page/licencias-sin-goce-de-haberes'
    },
    {
      'Id':9,
      'Articulo': '14ext',
      'Descripcion':'Se debe adjuntar la nota explicando el motivo de su extensión, una vez transcurrido los 120 días, se puede expandir hasta 180 días (sumando los 120dias + 60dias) pero a partir de esta renovación está ya correría sin goce de haberes.',
      'Link': 'https://docs.saed.digital/books/circular/page/licencias-sin-goce-de-haberes'
    }],
    Personal: null,
    EstadoSolicitudMedica: 0,
    Fecha: null,
    FechaDesde: null,
    CantidadDias: 0,
    FechaHasta: null,
    FechaPresentacion:null,
    TipoSolicitudMedica: 0,
    Personal_Id: 0,
    unidadeducativa_id: 0,
    nivelenseñanza_id: 0,
    UnidadAdministrativa_Id: 1,
    ListaCargoPersonal_Id: 0,
    ListaCargoPersonal: [],
    ListaCargoPersonalSeleccionado: [],
    Observaciones: '',
    TipoLicencia_Id: 0,
    DetalleDiasLicencia_Id: 0,
    TipoLicencia: null,
    DetalleDiasLicencia: null
  },
  mutations: {
    updateSolicitudField,
  },
  getters: {
    getSolicitudField,
  }
};



// WEBPACK FOOTER //
// ./src/store/formsolicitud.js